import React from "react";

import { Box, CardActionArea, CardMedia, FormHelperText, Paper, PaperProps, Typography } from "@material-ui/core";
import clsx from "clsx";

import MenuItem from "api/types/MenuItem";
import makeStyles from "hooks/makeStyles";
import useFormatMoney from "hooks/useFormatMoney";
import useLocalize from "hooks/useLocalize";
import useTranslation from "hooks/useTranslation";

const useStyles = makeStyles(theme => ({
	root: {
		margin: 0,
		borderRadius: 4,
		color: theme.palette.text.primary,
		backgroundColor: theme.palette.background.default
	},
	actionArea: {
		display: "flex",
		flex: 1,
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "flex-start",
		boxSizing: "border-box",
		borderRadius: 4,
		backgroundColor: "#fcfcfc",
		minHeight: 120,
		overflowX: "auto",
		position: "relative",
		boxShadow: "2px 2px 4px 2px rgba(32, 32, 32, 0.1)"
	},
	textArea: {
		display: "flex",
		flex: 1,
		flexDirection: "column",
		justifyContent: "space-between",
		minHeight: 108,
		margin: 0,
		padding: theme.spacing(2)
	},
	titleRow: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start"
	},
	title: {
		fontWeight: 600,
		fontSize: 16,
		color: "#30323b",
		alignSelf: "left"
	},
	desc: {
		fontSize: 14,
		fontWeight: 400,
		color: "#646464",
		maxWidth: "100%",
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 2,
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	price: {
		fontWeight: 500,
		fontSize: 14,
		color: "#4f4f4f",
		alignSelf: "left",
		paddingTop: theme.spacing(2)
	},
	imageContainer: {
		width: "100%",
		height: "240px"
	},
	imageCard: {
		height: "100%"
	},
	code: {
		paddingTop: 10,
		fontSize: 12,
		position: "absolute",
		right: theme.spacing(1),
		bottom: theme.spacing(1)
	},
	outOfStock: {
		color: "#4f4f4f",
		textTransform: "capitalize"
	}
}));

interface Props extends PaperProps {
	item: MenuItem;
}

const MenuItemCardDesktop = ({ className, item, ...otherProps }: Props) => {
	const { formatMoney } = useFormatMoney();
	const { localize } = useLocalize();
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Paper className={clsx(classes.root, className)} elevation={0} {...otherProps}>
			<CardActionArea component="a" className={classes.actionArea} href={`#item:${item.id}`}>
				{item.imageUrl && (
					<Box className={classes.imageContainer}>
						<CardMedia image={item.imageUrl} className={classes.imageCard}></CardMedia>
					</Box>
				)}
				<Box className={classes.textArea}>
					<Box className={classes.titleRow}>
						{item.outOfStock && <FormHelperText className={classes.outOfStock}>{t("-outOfStock-")}</FormHelperText>}
						<Typography className={classes.title}>{localize(item.localeNames, item.name)}</Typography>
						<Typography className={classes.desc}>{item.description}</Typography>
					</Box>
					<Typography className={classes.price}>{formatMoney(item)}</Typography>
				</Box>
			</CardActionArea>
		</Paper>
	);
};

export default MenuItemCardDesktop;
